﻿require(["jquery", "registerHelper"],
    function ($, registerHelper) {
            var indexScript = function () {
            this.init();
        };

        indexScript.prototype.init = function () { };
        
        $(function () {
            registerHelper.init();
        });

    });